<template>
  <div class="user_list_page">
    <pageTitle v-bind="{ ...pT }" />
    <business-group :tableConfig="{ ...tableConfig }" :formConfig="{ ...formConfig }">
      <template slot="formSlot" slot-scope="formSlot">
        <a-form-item>
          <a-input
            placeholder="请输入设备名或mac地址"
            v-decorator="['keyword']"
            style="width: 200px; margin-right: 10px; vertical-align: middle"
          />
        </a-form-item>
        <a-form-item>
          <a-select placeholder="请选择设备类型" v-decorator="['deviceType']" style="width: 150px">
            <a-select-option v-for="el in deviceType.select" :value="el.value" :key="el.value"
              >{{ el.label }}
            </a-select-option>
          </a-select>
        </a-form-item>
      </template>
      <template slot="deviceType" slot-scope="record">
        <span v-text="deviceType.enumerate[record.deviceType]" />
      </template>
    </business-group>
  </div>
</template>

<script>
import moment from "moment";
import pageTitle from "@/components/business/pageTitle";
import businessGroup from "@/components/business/businessGroup";
import formTime from "@/components/business/Form/formTime";
import { deviceType } from "@/utils/pageMaps";

export default {
  components: {
    pageTitle,
    businessGroup,
    formTime,
  },
  data() {
    return {
      deviceType,
      pT: {
        pageTitle: "设备列表",
        // headerTitle: '绑定时间',
        // text: '(单次操作不超过1年)',
      },
      tableConfig: {
        url: "bluetoothlight/web/devices",
        columns: [
          {
            title: "绑定时间",
            dataIndex: "bindTime",
            key: "bindTime",
            align: "center",
          },
          {
            title: "设备类型",
            key: "deviceType",
            align: "center",
            scopedSlots: { customRender: "deviceType" },
          },
          {
            title: "设备型号",
            dataIndex: "deviceModel",
            key: "deviceModel",
            align: "center"
          },
          {
            title: "绑定用户",
            dataIndex: "nickname",
            key: "nickname",
            align: "center",
          },
          {
            title: "MAC地址",
            dataIndex: "deviceCode",
            key: "deviceCode",
            align: "center",
          },
          {
            title: "上传时间",
            dataIndex: "createTime",
            key: "createTime",
            align: "center",
          },
        ],
        rowKey: "deviceCode",
      },
      formConfig: {
        timeShow: true,
        formShow: true,
      },
    };
  },
  methods: {
    moment,
    imports() {
      this.$router.push({
        path: "/equipment_import",
      });
    },
  },
};
</script>


<style lang="less" scoped>
.user_list_page {
  .list_button {
    width: 80px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    border: none;
    color: #fff;
    font-size: 12px;
    border-radius: 5px;
    margin-right: 10px;
  }
}
</style>
